<div class="row">
  <mat-form-field class="w-100" floatLabel="auto">
    <!-- <mat-label>Enter notes about a user...</mat-label> -->
    <textarea matInput placeholder="Notes" [value]="value" (input)="onValueChanged($event)"></textarea>
  </mat-form-field>
</div>